export default "__VITE_ASSET__BJSBMmWv__"